import React from 'react';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import InputSelect from '../Symbols/InputSelect';
import Button from '../Symbols/Button';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import Result from './Result';
import Row from '../Symbols/Row';
import { claimTypeOptions, husbandOptions } from './Options';

export default function exekuce(props) {
	const errors = props.errors || {};

	return (
		<Wrapper>
			<Form onSubmit={props.onSubmit} title="Výpočet exekuce srážkami ze mzdy">
				<InputCurrency
					label="Čistá mzda"
					name="pay"
					value={props.state.pay}
					onChange={props.changeHandler('pay')}
					onBlur={props.validateHandler('pay')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'wage' }}
					error={errors.pay}
				/>

				<InputSelect
					label="Typ pohledávky"
					onChange={props.changeHandler('type')}
					onBlur={props.validateHandler('type')}
					value={props.state.type}
					name="type"
					select={claimTypeOptions}
					error={errors.type}
				/>

				<InputSelect
					label="Uplatní se nezabavitelná částka za manžela/manželku"
					onChange={props.changeHandler('husband')}
					onBlur={props.validateHandler('husband')}
					value={props.state.husband}
					name="husband"
					select={husbandOptions}
					error={errors.husband}
				/>

				<Input
					label="Počet dětí, ke kterým máte vyživovací povinnost"
					name="children"
					value={props.state.children}
					type="number"
					onChange={props.changeHandler('children')}
					onBlur={props.validateHandler('children')}
					passedProps={{ min: 0, max: 10, step: 1, 'data-cy': 'children' }}
					error={errors.children}
				/>

				<div css={Row}>
					<Button data-cy="submit">VYPOČÍTAT</Button>
				</div>

				{props.result && <Result result={props.result} />}
				{props.result && (
					<div css={Row}>
						<Button onClick={props.reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
}
